import { HandleSubmitProps } from "interfaces";

interface formValues {
  choice: string;
}

export default function (
  values: formValues,
  { props: { action } }: HandleSubmitProps
) {
  return action({ ...values });
}
